import loginImage from "../Images/side img.svg";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useHistory, useLocation } from "react-router-dom";
import verifyImg from "../Images/Verified-rafiki 1.svg";
export default function VerifyEmail() {
  const locData = useLocation();
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  function loginUser() {
    setSpinner(true);
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/resend-email-verify/${locData.state}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
         
        }
      })
      .catch((err) => console.log("Error"));
  }
  return (
    <div className="login-parent-container md:grid md:grid-cols-2 md:gap-4">
      <div className="hidden md:block">
        <img
          src={loginImage}
          alt=""
          style={{ width: "50vw", height: "100vh", objectFit: "cover" }}
        />
      </div>

      <div className="loginLayout">
        <div style={{padding:"12px",display:"flex",flexDirection:"column",gap:"10px"}}>
          <img
            src={verifyImg}
            alt=""
            style={{ width: "300px", height: "300px",alignSelf:"center" }}
          />

          <div className="confirmmail">Confirm your email</div>
          <div className="subtextverifyemail">
            To continue to your Account, please confirm your email by clicking
            the link in the email we’ve just sent you.
          </div>

          <div>
            <div className="subtextverifyemail">
              Didn’t receive an email
            </div>
            <div
              onClick={() => {
                loginUser();
              }}
              style={{ marginTop: "8px" }}
              className="loginBtn"
            >
              {spinner ? (
                <CircularProgress
                  style={{
                    color: "var(--color-white, #FFF)",
                    height: "20px",
                    width: "20px",
                  }}
                />
              ) : (
                "Resend"
              )}
            </div>
          </div>

          <div className="dontHaveLayout" style={{marginTop:"0px"}}>
            <div className="dontText">Already have an account?</div>
            <div
              className="signUpText"
              onClick={() => {
                history.push("/Login");
              }}
            >
              Login now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
